export default function CTASection() {
  return (
    <section className="relative h-[500px] md:h-[550px] w-full overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20sunlit%20lifestyle%20product%20photography%20with%20soft%20golden%20hour%20natural%20light%2C%20clean%20minimalist%20aesthetic%2C%20scattered%20lifestyle%20products%20on%20light%20airy%20surface%2C%20warm%20cream%20and%20soft%20beige%20tones%2C%20peaceful%20modern%20atmosphere%2C%20editorial%20catalog%20style%2C%20gentle%20shadows%2C%20aspirational%20lifestyle%20feel%2C%20bright%20airy%20room%20with%20natural%20window%20light&width=1920&height=960&seq=gtbuy-cta-bg&orientation=landscape"
        alt="Start comparing today with GTBuy Spreadsheet"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/40"></div>

      <div className="absolute inset-0 flex flex-col items-center justify-center px-4 md:px-6">
        <h2 className="text-3xl md:text-5xl lg:text-6xl font-heading font-extrabold text-white text-center tracking-wide uppercase mb-3">
          Buy Smarter Today
        </h2>
        <p className="text-white/65 text-base md:text-lg text-center max-w-lg mb-10 leading-relaxed">
          Stop guessing. Start comparing with the most comprehensive spreadsheet shopping tool available.
        </p>
        <a
          href="https://kaspreadsheet.com"
          target="_blank"
          rel="noopener nofollow"
          className="group inline-flex items-center gap-3 px-8 py-4 rounded-full bg-foreground-900 text-white text-base font-semibold hover:bg-foreground-800 transition-all whitespace-nowrap cursor-pointer"
        >
          <span className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-500">
            <i className="ri-shopping-bag-line text-white text-sm"></i>
          </span>
          <span>GTBuy Sheet</span>
          <i className="ri-arrow-right-up-line text-lg group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"></i>
        </a>
      </div>
    </section>
  );
}